import React from 'react';
import Product from '../../models/Product';
import { ICountry } from '../../models/Message';
import { List } from 'immutable';
import I18n from '../../lib/i18n';
import GlyphPopover from '../../lib/components/GlyphPopover';

interface IProps {
  product: Product;
  countries: List<ICountry>;
  platforms: string[];
  handleDeleteClick?: () => void;
}

export default class SingleProductRow extends React.PureComponent<IProps> {
  public render(){
    const { product, countries, platforms, handleDeleteClick } = this.props;
    if (!product){ return null; }
    const isValidProduct = product.valid && product.isValidAvailableCountries(countries.map(e => e.iso2).toArray(), platforms);
    const baseStyle = { padding: '0.5rem 1rem', marginBottom: '.5rem' };
    let title;
    let body;
    let style;
    if (isValidProduct) {
      title = product.availableName();
      body = `[${I18n.t('activerecord.attributes.product.oldest_release_at')}]<br />${product.oldest_release_at}`;
      style = { ...baseStyle, border: '1px dashed gray' };
    } else {
      title = `${product.ns_uid}: ${I18n.t('products.index.invalid_product')}`;
      body = I18n.t('messages.tooltips.invalid_product');
      style = { ...baseStyle, border: '1px dashed red' };
    }
    return(
      <div className='product-row' style={style}>
        {title}
        { handleDeleteClick &&
          <div style={{ float: 'right' }} onClick={handleDeleteClick}>
            <span style={{ color: 'red' }} className='glyphicon glyphicon-remove' />
          </div>
        }
        <div style={{ float: 'right', marginRight: '10px' }}>
          <GlyphPopover {...{ title, body }} glyph='info-sign' dangerouslySetInnerHTML={true} />
        </div>
      </div>
    );
  }
}
